import { useMediaQuery, useTheme } from '@mui/material';

export default function useIsDesktop() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'));
}
